import Guid from "./../factories/guid";
import * as ko from "knockout";

class AreaEquipmentDetail {
   
    AreaEquipmentDetailId = ko.observable(Guid());
    AreaEquipmentId = ko.observable();
    AreaId = ko.observable();
    EquipmentText = ko.observable();
    EquipmentDescription = ko.observable();
    AreaText = ko.observable();
    AreaDescription = ko.observable();
    DeleteDate = ko.observable();
    IsDeleted = ko.observable(false);
};

export default AreaEquipmentDetail;